import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Only register in production builds
    if (import.meta.env.PROD === false) {
      return;
    }

    navigator.serviceWorker
      .register('/service-worker.js')
      .catch(error => {
        console.error('Service worker registration failed:', error);
      });
  });
}
